module.exports = __webpack_public_path__ + "static/media/12UNCTAD8.a9e01348.jpg";